// Handles the generation and persistence of event ID and event_time

/**
 * Sets a cookie in the browser.
 * @param {string} name - The name of the cookie.
 * @param {string} value - The value of the cookie.
 * @param {number} [days] - The number of days until the cookie expires.
 */
function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

/**
 * Gets the value of a cookie from the browser.
 * @param {string} name - The name of the cookie.
 * @returns {string|null} The value of the cookie, or null if not found.
 */
function getCookie(name) {
  let nameEQ = name + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
/**
 * Gets or creates a unique event ID for the current checkout session.
 * This ID persists in sessionStorage (for refreshes) and cookies (for cross-session consistency for the same user).
 * @returns {string} The unique event ID.
 */
export function getOrCreateEventId(eventName, id, event_key, existing_key) {
  return `${eventName}_${id}_${existing_key ?existing_key : event_key}`;
}

/**
 * Gets or creates the initial event_time (Unix timestamp in seconds) for the current checkout session.
 * This time reflects the order creation time and persists with the event ID.
 * @returns {string} The Unix timestamp in seconds.
 */
export function getOrCreateEventTime() {
  let eventTime = sessionStorage.getItem("meta_event_time");
  if (!eventTime) {
    eventTime = getCookie("meta_event_time");
    if (!eventTime) {
      // Get current Unix timestamp in seconds
      eventTime = Math.floor(Date.now() / 1000).toString();
      setCookie("meta_event_time", eventTime, 7); // Persist for 7 days
    }
    sessionStorage.setItem("meta_event_time", eventTime);
  }
  return eventTime;
}
